
import Map from "../../../assets/filled/Map.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MapIcon({ className, dataTestid = "MapIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Map data-testid={dataTestid} className={classes} {...rest} />
  );
}
